<template>
  <div class="pay-successCon">
    <div class="pay-success flexJC alignItem">
      <span class="paySuccess-icon mb22"></span>
      <p class="f28 mb20">支付成功</p>
      <p class="color-9 f18">您已付款成功，正在跳转</p>
      <p class="color-9 f18 pt5">请稍后...</p>
    </div>
  </div>
  <!--弹框-->
  <!--<div class="shade" v-show="isLoading">-->
  <!--<div class="flexJC alignItem showLoading">-->
  <!--<img src="../../static/images/Spinner_1.gif" alt="" class="icon_loading"/>-->
  <!--</div>-->
  <!--</div>-->
</template>
<script>
import cabinetServ from '../../service/cabinetServ'
import cache from '../../service/cacheServ'
import wxServ from '../../service/wxServ'
import mintUi from '../../lib/mint-ui'
import zfbServ from '../../service/zfbServ'
export default {
  data() {
    return {
      count: '',
      isLoading: false
    }
  },
  created() {
    let qrCode = this.$route.query.qrcode;
    let openId = this.$route.query.openId;
    this.getCabinetSta(qrCode);
    this.getUserInfo(openId)
  },
  methods: {
    // 查询柜门是否打开
    getOpenDor(cabinetNo, orderNo, customerWxId, qrCode) {
      cabinetServ.getIsOpenDoor(cabinetNo, orderNo, customerWxId, qrCode)
        .then(res => {
          if (res.code === '200') {
            if (res.data.cabinetStatus == 'online') { // 在线
              if (!res.data.orderStatus) {
                mintUi.Toast({
                  message: '订单不存在，如有疑问请联系管理员',
                  position: 'bottom'
                })
              } else {
                if (res.data.orderStatus == '1') { // 已支付
                  if (parseInt(res.data.doorId) > 0) {// 已支付 门已开
                    this.$router.push({ path: '/alipayOpenSuccess', query: { qrCode: qrCode, orderNo: orderNo, openId: customerWxId } })
                  } else {// 已支付 门未开 去开门
                    this.$router.push({ path: '/alipayOpenDoorUnSuccess', query: { qrCode: qrCode, orderNo: orderNo, openId: customerWxId } })
                  }
                } else if (res.data.orderStatus == '2') {// 已借出
                  this.$router.push({ path: '/alipayOpenSuccess', query: { qrCode: qrCode, orderNo: orderNo, openId: customerWxId } })
                } else {// 其他状态去异常页面
                  this.$router.push({ path: '/alipayNoNormal', query: { qrCode: qrCode, orderNo: orderNo, openId: customerWxId } })
                }
              }
            } else {
              this.$router.push({ path: '/alipayNoNormal', query: { qrCode: qrCode, orderNo: orderNo, openId: customerWxId } })
            }
          } else {
            this.$router.push({ path: '/alipayNoNormal', query: { qrCode: qrCode, orderNo: orderNo, openId: customerWxId } })
          }
        })
    },
    goToUrl() {
      window.location.href = 'http://www.aigehui028.com/'
    },
    // 获取设备状态
    getCabinetSta(qrCode) {
      this.isLoading = true;
      cabinetServ.getCabinetStatus(qrCode).then((res) => {
        this.isLoading = false;
        if (res.code == '200') {
          if (!res.data) {
          } else {
            this.cabinetInfo = res.data;
            let cabinetNo = res.data.cabinet.cabinetNo;
            cache.set('cabinetInfo', res.data, true);
            let customerWxId = this.$route.query.openId;
            let orderNum = this.$route.query.orderNo;
            this.getOpenDor(cabinetNo, orderNum, customerWxId, qrCode)
          }
        } else {
          mintUi.Toast({
            message: res.message,
            position: 'bottom'
          })
        }
      })
    },
    getUserInfo(id) {
      zfbServ.getUserInfoOpenId(id).then(res => {
        if (res.code == '200') {
          cache.set('user', res.data, true)
        } else {
          mintUi.Toast({
            message: res.message,
            position: 'bottom'
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.pay-successCon {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 2;
}
.pay-success {
  padding-top: 100px;
}
.paySuccess-icon {
  width: 57px;
  height: 57px;
  background: url("/static/images/paySuccess-icon.png") no-repeat;
  background-size: 100% 100%;
}
</style>




// WEBPACK FOOTER //
// src/pages/alipay/alipayPaySuccess.vue